export default __webpack_public_path__ + "static/media/Foto017.321327bb.png";